import type { ValuesOf } from "app/helpers/types/iterables";
import type { SignalType, SignalFilters } from "app/pages/sales-intelligence/domain/signals/types/signal";
import type {
    I18nKeyModifier,
    TranslatableNameWithType,
} from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterNamingService";
import type UISignalDataDeps from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignalDataDeps";

export enum FilterType {
    Countries = "countries",
    AdNetworks = "adNetworkIds",
    Technologies = "technologies",
    NewsCategories = "newsCategories",
    AnyNewsCategories = "anyNewsCategories",
    IntentTopics = "topics",
}

export interface FilterNameResolver {
    buildName(
        filters: SignalFilters,
        options: ValuesOf<UISignalDataDeps>,
        translationOptions?: Readonly<I18nKeyModifier>,
    ): Readonly<TranslatableNameWithType>;
}

export type FiltersEqualityPredicate = (
    filters: Readonly<SignalFilters>,
    comparedFilters: Readonly<SignalFilters>,
) => boolean;

export interface FilterService {
    getFilterName(filterType: FilterType): FilterNameResolver;

    /** @throws Error */
    getFiltersEqualityPredicate(signalType: SignalType): FiltersEqualityPredicate;
}
